import { useContext } from 'react';
import Section from '~/constants/vdp/section';
import GlobalContext from '~/context/vdp/GlobalContext';
import { useSectionViewed } from '~/context/vdp/UiContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';
import useGetShouldRenderBelowSpinner from './useGetShouldRenderBelowSpinner';

export default function useShouldLoadFirstSection() {
  const shouldRenderBelowSpinner = useGetShouldRenderBelowSpinner();
  const { isLazyLoadEnabled } = useContext(GlobalContext);
  const isWip = useGetIsWIPVehicle();
  const wasGalleryViewed = useSectionViewed(Section.Gallery);

  return (
    shouldRenderBelowSpinner &&
    (!isLazyLoadEnabled || wasGalleryViewed || isWip)
  );
}
